export default __webpack_public_path__ + "static/9_32-50ba6869696174c750b2af9790995a90.png";